import { apiRoutes } from "../Constant/ApiRoutes";
import { getRequest, putRequest } from "../apiRequest";

// Helper to get the current KB ID for scoping API calls in multi-KB mode
const getKbParams = () => {
  const kbId = window.__kbId;
  return kbId ? { knowledgeBaseId: kbId } : undefined;
};

export const getUsersList = () => {
  return getRequest(apiRoutes.kbUsers, getKbParams());
};

export const updateKbUsers = (payload) => {
  return putRequest(apiRoutes.kbUsers, payload, getKbParams());
};
